<template>
  <div class="teaching-book">
    <div class="demo-book-resource">
      <div class="left-category">
        <div>
          <div class="title theme-title active-title">课程类型</div>
          <ul class="drop-menu drop-menu2">
            <li
              v-preventRepeat="800"
              :class="currentIndex == index ? 'active-li2' : ''"
              v-for="(item, index) in classifyList"
              :key="index"
              @click="classList(item.id, index)"
            >
              <el-tooltip
                :content="item.label"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <a href="javascript:;"
                  ><span class="ellipsis-aRow">{{ item.label }}</span></a
                >
              </el-tooltip>
            </li>
          </ul>
        </div>
        <div style="margin-top: 20px">
          <div class="title theme-title active-title">四套卷</div>
          <ul class="drop-menu drop-menu2">
            <li
              v-preventRepeat="800"
              :class="currentIndex1 == index ? 'active-li2' : ''"
              v-for="(item, index) in trainingList"
              :key="index"
              @click="training(item.id, index)"
            >
              <el-tooltip
                :content="item.label"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <a href="javascript:;"
                  ><span class="ellipsis-aRow">{{ item.label }}</span></a
                >
              </el-tooltip>
            </li>
          </ul>
        </div>
      </div>
      <div class="right-book-resource">
        <div class="header-select-search">
          <div class="search">
            <input
              type="text"
              v-model.trim="queryParams.resourceName"
              class="custom-input"
              @keyup.enter="handleQuery"
              placeholder="请输入"
            />
            <el-button
              type="primary"
              class="custom-button"
              icon="el-icon-search"
              @click="handleQuery"
              >搜索</el-button
            >
          </div>
        </div>
        <el-tabs
          class="intabs"
          v-preventRepeat="800"
          v-model="activeName"
          @tab-click="handleClick"
        >
          <el-tab-pane name="create_time">
            <span slot="label"
              >最新
              <img
                v-show="sortType == 'desc'"
                src="@/assets/icon/willingLearnup.png"
              />
              <img
                v-show="sortType == 'asc'"
                src="@/assets/icon/willingLearndown.png"
              />
            </span>
            <booklist-box :data-list="bookList"></booklist-box>
            <noData v-if="total == 0"></noData>
            <div class="pagination-box" v-show="total > 0">
              <el-pagination
                class="ou-pagination"
                background
                hide-on-single-page
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="queryParams.pageSize"
                layout="total, prev, pager, next, sizes, jumper, slot"
                :total="total"
              >
                <el-button @click="getList()" class="ou-page-go">GO</el-button>
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane name="viewer_number">
            <span slot="label"
              >热门
              <img
                v-show="sortType1 == 'desc'"
                src="@/assets/icon/willingLearnup.png"
              />
              <img
                v-show="sortType1 == 'asc'"
                src="@/assets/icon/willingLearndown.png"
              />
            </span>
            <booklist-box :data-list="bookList"></booklist-box>
            <noData v-if="total == 0"></noData>
            <div class="pagination-box" v-show="total > 0">
              <el-pagination
                class="ou-pagination"
                background
                hide-on-single-page
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="queryParams.pageSize"
                layout="total, prev, pager, next, sizes, jumper, slot"
                :total="total"
              >
                <el-button @click="getList()" class="ou-page-go">GO</el-button>
              </el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { GetBooksList, GetTreeSelectByType } from "@/api/willingLearn/index.js";
import noData from "@/components/noData.vue";
import booklistBox from "@/components/learnBooklistBox.vue";
export default {
  components: { booklistBox, noData },
  data() {
    return {
      fieldName: "create_time",
      sortType: "desc",
      sortType1: "asc",
      bookList: [],
      total: 10,
      activeName: "create_time",
      currentIndex: "",
      currentIndex1: "",
      classMenuList: [
        {
          label: "全部",
          id: "",
        },
        {
          label: "肖秀荣考研政治",
          id: "100702",
        },
        {
          label: "考研英语",
          id: "100703",
        },
        {
          label: "考研数学",
          id: "100704",
        },
      ],
      trainingList: [
        {
          label: "全部",
          id: "",
        },
        {
          label: "是",
          id: "dollors",
        },
        {
          label: "否",
          id: "nothing",
        },
      ],
      queryParams: {
        goodsType: "train", //商品类型
        sortList: [
          //最新销量热门
          {
            fieldName: "create_time",
            type: "desc",
          },
        ],
        resourceName: "",
        specialMark: "",
        resourceType: "",
        pageNum: 1,
        pageSize: 10,
      },
      type: "",
      classifyList: [],
    };
  },
  mounted() {
    this.getList();
    this.getTreeType();
    console.log(this.$route.query.type);
    this.type = this.$route.query.type;
  },
  methods: {
    // 乐学下拉列表
    getTreeType() {
      let data = {
        catalogType: "train_property",
      };
      GetTreeSelectByType(data).then((res) => {
        let list = res.data;
        list.unshift({
          id: null,
          label: "全部",
        });
        if (this.classifyList.length == 0) {
          this.classifyList = list;
        }
      });
    },
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //排序
    handleClick(tab) {
      this.queryParams.pageNum = 1;
      this.queryParams.sortList[0].fieldName = tab.name;
      if (this.queryParams.sortList[0].fieldName == tab.name) {
        if (tab.name == "create_time") {
          // this.sortType1 = "asc";
          if (this.sortType == "asc") {
            this.sortType = "desc";
          } else {
            this.sortType = "asc";
          }
          this.queryParams.sortList[0].type = this.sortType;
        } else {
          // this.sortType = "asc";
          if (this.sortType1 == "asc") {
            this.sortType1 = "desc";
          } else {
            this.sortType1 = "asc";
          }
          this.queryParams.sortList[0].type = this.sortType1;
        }
      }
      this.getList();
    },
    training(id, index) {
      this.currentIndex1 = index;
      this.queryParams.specialMark = id;
      this.getList();
    },
    classList(id, index) {
      this.currentIndex = index;
      this.queryParams.resourceType = id;
      this.getList();
    },
    getList() {
      //获取最新图书列表
      GetBooksList(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.bookList = res.rows;
          this.total = res.total;
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
.teaching-book {
  height: auto;
  background: #fbfbfb;
  // padding: 50px 0;
  .demo-book-resource {
    width: 1400px;
    min-height: 460px;
    margin: 0 auto;
    display: flex;
    .left-category {
      width: 304px;
      height: 500px;
      background: #fffefd;
      margin-right: 16px;
      box-sizing: border-box;
      padding: 12px 5px 14px 26px;
      .title {
        font-size: 14px;
        cursor: pointer;
      }
      .title {
        margin-bottom: 20px;
      }
      .title:nth-of-type(2) {
        margin-top: 10px;
      }
      .active-title {
        color: #2e9adb;
        margin-top: 10px;
        font-size: 16px;
      }
      .drop-menu {
        overflow: auto;
        padding: 10px 5px;

        li {
          line-height: 21px;
          margin-bottom: 10px;
          a {
            text-decoration: none;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span {
              width: 208px;
            }
            img {
              width: 7px;
              height: 12px;
            }
          }
        }
        .active-li2 {
          > a {
            color: #2e9adb;
          }
          img {
            width: 12px;
            height: 7px;
          }
        }
      }
      .drop-menu::-webkit-scrollbar {
        width: 5px;
      }
      .drop-menu::-webkit-scrollbar-thumb {
        background-color: rgba(144, 147, 153, 0.3);
        border-radius: 4px;
      }
      .drop-menu::-webkit-scrollbar-thumb:hover {
        background-color: rgba(144, 147, 153, 0.5);
      }
      .drop-menu::-webkit-scrollbar-track {
        border-radius: 4px;
        background: #fff;
      }
      .drop-menu2 {
        li {
          margin-bottom: 30px;
        }
        li:last-child {
          margin-bottom: 0;
        }
      }
    }
    .right-book-resource {
      width: 1080px;
      min-height: 460px;
      background: #fffefd;
      box-sizing: border-box;
      padding-left: 20px;
      position: relative;
      padding-top: 10px;
      .header-select-search {
        margin-top: 4px;
        height: 35px;
        display: flex;
        align-items: center;
        position: absolute;
        top: -30px;
        right: 20px;
        .resource-type {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #666666;
          display: flex;
          align-items: center;
          span {
            cursor: pointer;
            text-align: center;
            padding: 5px 10px;
            height: 18px;
            box-sizing: border-box;
            line-height: 12px;
          }
          .active-type {
            background: #2e9adb;
            border-radius: 11px;
            color: #ffffff;
          }
        }

        .search {
          position: absolute;
          right: 30px;
          top: 35px;
          z-index: 999;
        }
      }
    }
  }
}
.pagination-box {
  text-align: right;
  margin: 25px 0;
}
</style>
